module.exports = __webpack_public_path__ + "img/好评.005949b3.png";